// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 15) return "static/js/18d379acd293c9334792.bundle.js";
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"dc7f2bfb6d3f3c9301b0","151":"1b5f75670c86b4229935","152":"61a5bd75ae7616a9b1e6"}[chunkId] + ".chunk.js";
};